import { useFetch } from "../../hooks/api";
import { useLocalStorage } from "@reactuses/core";
import { useTranslation } from "react-i18next";
import chromeStoreLogo from "../../assets/images/logo/chrome_store.png";
import DismissibleBanner from "../core/basic/DismissibleBanner";

const ChromeExtensionBanner = () => {
  const { t } = useTranslation(["chrome_extension"]);
  const [isDismissed] = useLocalStorage<string | null>("dismiss_chrome_extension_banner", null);
  const { data } = useFetch<{ has_extension?: boolean }>(
    ["chrome_extension"],
    "/api/chrome_extension",
    {},
    { enabled: !isDismissed, select: (d) => d.data },
  );

  if (isDismissed) {
    return null;
  }

  if (data) {
    return (
      <DismissibleBanner storageKey={"dismiss_chrome_extension_banner"}>
        <a
          href="https://chromewebstore.google.com/detail/trellis-seller-extension/mfnnikclhbphfbkojdfoeccbfpjcbbdl?utm_source=portal&utm_medium=web&utm_campaign=trellis_banner"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            textDecoration: "none",
            fontWeight: "bold",
            color: "white",
          }}
        >
          <img
            src={chromeStoreLogo}
            alt={t(($) => $.chrome_extension["Google Chrome Store"])}
            style={{ height: "40px", backgroundColor: "white" }}
          />
          <span className="ps-3">
            {t(($) => $.chrome_extension["Checkout our Browser Extension for Amazon Sellers Today!"])}
          </span>
        </a>
      </DismissibleBanner>
    );
  }

  return null;
};

export default ChromeExtensionBanner;
